module.exports = __webpack_public_path__ + "img/lr.db3caedf.jpg";